import { DocumentUploadValidationError } from '../../../../types/errors/validation';

export const MAX_FILE_SIZE = 200;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE * 1024 * 1024;
export const MAX_CHARACTERS = 90;

export const validateFileSize = (file: File): void => {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new DocumentUploadValidationError(`Upload failed. Please ensure that the file size is less than ${MAX_FILE_SIZE}MB. Then try again`);
  }
};

export const validateFileExtension = (file: File, allowedExtensions: string): void => {
  const allowed = allowedExtensions
    .replace(/\./g, '')
    .split(',')
    .map((ext) => ext.trim().toLowerCase());
  const fileExtension = file.name.split('.').pop()?.toLowerCase();

  if (fileExtension && !allowed.includes(fileExtension)) {
    throw new DocumentUploadValidationError(`Upload failed. Please ensure that the file extension is one of ${allowedExtensions}. Then try again`);
  }
};

export const validateFileNameLength = (file: File): void => {
  if (file.name.length >= MAX_CHARACTERS) {
    throw new DocumentUploadValidationError(`Upload failed. Please ensure that the file name is less than ${MAX_CHARACTERS} characters. Then try again`);
  }
};
